import { render, staticRenderFns } from "./ExpiryMessage.vue?vue&type=template&id=2c542554"
import script from "./ExpiryMessage.vue?vue&type=script&lang=js"
export * from "./ExpiryMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c542554')) {
      api.createRecord('2c542554', component.options)
    } else {
      api.reload('2c542554', component.options)
    }
    module.hot.accept("./ExpiryMessage.vue?vue&type=template&id=2c542554", function () {
      api.rerender('2c542554', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ExpiryMessage.vue"
export default component.exports